module.exports = __webpack_public_path__ + "img/SWE.221cd4bf.svg";